import axios from '@/api/tool'

/*获取级联菜单数据 三级*/
export function getCascadeDictData(type) {
  return axios({
    url: "/common/dict/queryCascadeDict?type=" + type,
    method: "get"
  })
}
/* 获取项目入参 */
export function projectManagementAll(data) {
  return axios({
    url: "/projectManagement/all",
    method: "post",
    data: data
  })
}


/*保存项目*/
export function saveProject(data) {
  return axios({
    url: "/projectManagement/save",
    method: "post",
    data: data
  })
}

/*回显项目*/
export function getProject(id) {
  return axios({
    url: "/projectManagement/query/" + id,
    method: "get"
  })
}

/*条件查询项目列表*/
export function queryProject(data) {
  return axios({
    url: "/projectManagement/queryAll",
    method: "post",
    data: data
  })
}

/*转非研发项目*/
export function changeProjectType(id) {
  return axios({
    url: "/projectManagement/change/" + id + "/2",
    method: "get"
  })
}

/*删除加计扣除项目*/
export function deleteProject(id) {
  return axios({
    url: "/projectManagement/delete/" + id,
    method: "delete"
  })
}


/*获取员工*/
export function getEmployee(data) {
  return axios({
    url: "/employee/list",
    method: "post",
    data: data,
  })
}


/*获取部门*/
export function getDepts() {
  return axios({
    url: "/employee/queryEmpGroupByDept",
    method: "post"
  })
}

/*保存员工*/
export function saveEmployee(data) {
  return axios({
    url: "/employee/saveOrUpdate",
    method: "post",
    data: data
  })
}

/*批量移除员工项目关联*/
export function removeEmployeeProjectRelation(data) {
  return axios({
    url: "/employee/deleteRelevance",
    method: "post",
    data: data
  })
}

/*批量设置项目参与/离开时间*/
export function employeeUpdateRelevance(data) {
  return axios({
    url: "/employee/updateRelevance",
    method: "post",
    data: data

  })
}


/*查询薪资列表*/
export function getSalary(data) {
  return axios({
    url: "/salary/list",
    method: "post",
    data: data
  })
}


/*删除薪资*/
export function deleteSalary(data) {
  return axios({
    url: "/salary/delete",
    method: "post",
    data: data
  })
}

/*保存薪资*/
export function saveSalary(data) {
  return axios({
    url: "/salary/saveOrUpdate",
    method: "post",
    data: data
  })
}


/*查询考勤列表*/
export function getCheck(data) {
  return axios({
    url: "/checking/list",
    method: "post",
    data: data
  })
}

/*保存考勤*/
export function saveChecking(data) {
  return axios({
    url: "/checking/saveOrUpdate",
    method: "post",
    data: data
  })
}


/*删除考勤*/
export function deleteChecking(data) {
  return axios({
    url: "/checking/delete",
    method: "post",
    data: data
  })
}


/*查询员工关联项目数据*/
export function queryEmpGroup(id) {
  return axios({
    url: "/employee/queryEmpGroup/" + id,
    method: "post"
  })
}

/*保存员工关联项目数据*/
export function addEmployeeProjectRelevance(data) {
  return axios({
    url: "/employee/addRelevance",
    method: "post",
    data: data
  })
}

/*删除员工*/
export function deleteEmployee(data) {
  return axios({
    url: "/employee/deleteEmployee",
    method: "post",
    data: data
  })
}

/*全部项目*/
export function getProjectList() {
  return axios({
    url: "/projectManagement/get",
    method: "get",
  })
}

/**
 * 备查资料年度
 */
export function exportsQueryAdditionalDeductionReferenceMaterialsAnnual(projectId) {
  return axios({
    url: '/exports/queryAdditionalDeductionReferenceMaterialsAnnual/' + projectId,
    method: 'get'
  })
}

/**
 * 备查资料列表
 * @param data
 */
export function exportsQueryAdditionalDeductionReferenceMaterials(data) {
  return axios({
    url: '/exports/queryAdditionalDeductionReferenceMaterials',
    method: 'post',
    data: data
  })
}

/**
 * 生成备查资料
 * @param data
 */
export function exportsDownloadList(data) {
  return axios({
    url: '/exports/downloadList',
    method: 'post',
    data: data
  })
}

/**
 * 生成人员工时记录
 * @param data
 */
export function exportsPersonnelTimeRecord(data) {
  return axios({
    url: '/exports/personnelTimeRecord',
    method: 'post',
    data: data
  })
}

/**
 * 生成项目研发人员名单
 * @param data
 */
export function exportsProjectRDPersonsList(data) {
  return axios({
    url: '/exports/projectRDPersonsList',
    method: 'post',
    data: data
  })
}

/*查询项目辅助帐*/
export function getProjectAccount(data) {
  return axios({
    url: "/exports/queryAuxiliaryAccount",
    method: "post",
    data: data
  })

}


/*单个项目生成*/
export function singleProjectGenerate(data) {
  return axios({
    url: "/exports/projectRDDetail",
    method: "post",
    data: data
  })
}

/*查询项目总账*/
export function queryAuxiliaryAccounts(data) {
  return axios({
    url: "/exports/queryAuxiliaryAccounts",
    method: "post",
    data: data
  })
}

/*下载单独辅助帐*/
export function downloadAccount(data) {
  return axios({
    url: "/exports/downloadAccount",
    method: "post",
    data: data
  })
}

/*打包下载总账*/
export function downloadAccounts(data) {
  return axios({
    url: "/exports/downloadAccounts",
    method: "post",
    data: data
  })
}


/*下载项目内辅助帐*/
export function downloadAuxiliaryAccount(id) {
  return axios({
    url: "/exports/downloadAuxiliaryAccount?id=" + id,
    method: "get"
  })
}

/*生成总账*/
export function totalGenerate(data) {
  return axios({
    url: "/exports/generate",
    method: "post",
    data: data
  })
}


/*统计,费用*/
export function costByType() {
  return axios({
    url: "/statistics/costByType",
    method: "post"
  })
}
/*统计,工时*/
export function manHour(data) {
  return axios({
    url: "/statistics/manHour",
    method: "post",
    data: data
  })
}

/*统计,研发费用*/
export function cost(data) {
  return axios({
    url: "/statistics/cost",
    method: "post",
    data: data
  })
}

/*查询薪资对应的奖金*/
export function querySalaryBonus(id) {
  return axios({
    url: "/salary/querySalaryBonus/" + id,
    method: "get"
  })
}

/*查询薪资对应的奖金*/
export function queryByNumber(id) {
  return axios({
    url: "/employee/queryByNumber/" + id,
    method: "get"
  })
}




